<template>
    <span v-if="fulfillmentStatus === FulfillmentState.FULFILLED"
          data-component="FulfillmentStatusLabel"
          class="label label-success">{{ l('KITCHEN_MODAL.FULFILLMENT_STATE--FULFILLED') }}</span>
    <span v-else-if="fulfillmentStatus === FulfillmentState.PART_FULFILLED"
          data-component="FulfillmentStatusLabel"
          class="label label-warning">{{ l('KITCHEN_MODAL.FULFILLMENT_STATE--PARTIAL') }}</span>
    <span v-else-if="fulfillmentStatus === FulfillmentState.UNFULFILLED"
          data-component="FulfillmentStatusLabel"
          class="label label-danger">{{ l('KITCHEN_MODAL.FULFILLMENT_STATE--UNFULFILLED') }}</span>
</template>

<script>

import FulfillmentState from '@/lib/Kitchen/FulfillmentState';
import { calculateFulfillmentState } from '@/lib/Kitchen/calculateFulfillmentState';

export default {
    props: {
        fulfillments: {
            type: Array,
            required: true,
        },
    },

    computed: {
        FulfillmentState() {
            return FulfillmentState;
        },

        fulfillmentStatus() {
            return calculateFulfillmentState(this.fulfillments);
        },
    },
};
</script>
